import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useUserStore } from '../stores/userStore';
import { trackPageView } from '../lib/gaEvents';
import { REFERRER_TYPE } from '../constants/gaEnums';

const getExternalReferrerType = () => {
  try {
    // referrer가 다른 도메인이면 external
    const referrer = document.referrer;
    if (referrer && new URL(referrer).hostname !== window.location.hostname) {
      return REFERRER_TYPE.EXTERNAL;
    }
    // referrer가 없어도 navigate 타입이면 SPA 외부 진입 (앱/카카오톡 등 링크 클릭 포함)
    const navType = performance?.getEntriesByType?.('navigation')?.[0]?.type;
    if (navType === 'navigate') return REFERRER_TYPE.EXTERNAL;
  } catch (_) {}
  return undefined;
};

/**
 * 페이지 진입 시 page_view 이벤트를 한 번 전송하는 훅
 * @param {object} params - trackPageView에 전달할 파라미터 (pageType 필수)
 * @param {object} [options]
 * @param {boolean} [options.ready=true] - 비동기 데이터(contentId 등)가 준비됐을 때 true로 전환
 */
const useTrackPageView = (params, { ready = true } = {}) => {
  const { state: locationState } = useLocation();
  const user = useUserStore((state) => state.user);
  const initialized = useUserStore((state) => state.initialized);
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current || !initialized || !ready) return;
    fired.current = true;
    const referrerType = locationState?.referrerType ?? getExternalReferrerType();
    const referrerSection = locationState?.referrerSection;
    trackPageView({ referrerType, referrerSection, ...params }, user);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialized, ready]);
};

export default useTrackPageView;
